var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('field-label',{attrs:{"field":_vm.field}}),_c('prism-editor',{staticClass:"css-editor",attrs:{"value":_vm.value,"highlight":_vm.highlighter,"line-numbers":"","tab-size":4},on:{"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }